import { addContext, dataDogLogger, removeContext } from 'features/observability/datadog';

import { isDatadogChannelEnabled } from '../channel-policy';
import { LogLevel } from '../log-level';

import { LoggerChannel, LoggerEvent } from './types';

/**
 * Web Datadog logger channel.
 *
 * The platform transport details — `datadogLogs` init/gating, level mapping,
 * error payload shape, and RUM error forwarding — live in
 * `features/observability/datadog` (`index.web.ts`). This channel owns the
 * routing boundary: when enabled it forwards normalized events to that
 * transport unchanged, preserving existing web delivery behavior.
 */
export const datadogChannel: LoggerChannel = {
  isEnabled: () => isDatadogChannelEnabled(),
  isEligible: (event: LoggerEvent) => event.level >= LogLevel.info,
  deliver: (event: LoggerEvent) => {
    dataDogLogger({
      message: event.attributes.message,
      context: event.attributes,
      status: event.level,
    });
  },
  syncContext: (context: Record<string, unknown>) => {
    // Web mirrors each string value into the browser SDK's context.
    for (const [key, value] of Object.entries(context)) {
      if (typeof value === 'string' && value.length > 0) {
        addContext(key, value);
      }
    }
  },
  removeContextKeys: (keys: string[]) => {
    for (const key of keys) {
      removeContext(key);
    }
  },
};
